export default "__VITE_ASSET__Cvy108vT__"